<button [attr.disabled]="disabled ? disabled : null" [type]="type">
  <ng-content></ng-content>
</button>
